<div
  class="modal-overlay"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="modalTitle"
  (click)="onBackdropClick($event)"
>
  <div class="modal-panel" role="document">
    <!-- Header -->
    <div class="modal-header">
      <div>
        <h2 class="modal-title">{{ modalTitle }}</h2>
        <p class="modal-subtitle" *ngIf="modalState() === 'form' || modalState() === 'submitting'">
          We will respond promptly.
        </p>
      </div>
      <button
        class="modal-close"
        (click)="onClose()"
        aria-label="Close modal"
        type="button"
        [disabled]="modalState() === 'submitting'"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- ── SUCCESS STATE ── -->
    <div class="modal-success" *ngIf="modalState() === 'success'" aria-live="polite">
      <div class="success-icon">
        <svg
          width="36"
          height="36"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      </div>
      <h3>Inquiry Sent</h3>
      <p>Thank you. {{ brokerName }} will contact you shortly.</p>
    </div>

    <!-- ── FORM & ERROR STATES ── -->
    <form
      *ngIf="modalState() === 'form' || modalState() === 'submitting' || modalState() === 'error'"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="modal-form"
      novalidate
    >
      <!-- Error Banner -->
      <div class="form-error-banner" *ngIf="modalState() === 'error'" role="alert">
        Something went wrong. Please try again.
      </div>

      <!-- Name Row -->
      <div class="form-row">
        <div class="form-field">
          <label for="inq-fname" class="field-label"
            >First Name <span class="required" aria-hidden="true">*</span></label
          >
          <input
            id="inq-fname"
            type="text"
            formControlName="firstName"
            class="field-input"
            [class.invalid]="firstNameCtrl.invalid && firstNameCtrl.touched"
            autocomplete="given-name"
            placeholder=""
            aria-required="true"
          />
          <span
            class="field-error"
            *ngIf="firstNameCtrl.invalid && firstNameCtrl.touched"
            role="alert"
          >
            First name required.
          </span>
        </div>
        <div class="form-field">
          <label for="inq-lname" class="field-label"
            >Last Name <span class="required" aria-hidden="true">*</span></label
          >
          <input
            id="inq-lname"
            type="text"
            formControlName="lastName"
            class="field-input"
            [class.invalid]="lastNameCtrl.invalid && lastNameCtrl.touched"
            autocomplete="family-name"
            placeholder=""
            aria-required="true"
          />
          <span
            class="field-error"
            *ngIf="lastNameCtrl.invalid && lastNameCtrl.touched"
            role="alert"
          >
            Last name required.
          </span>
        </div>
      </div>

      <!-- Email -->
      <div class="form-field">
        <label for="inq-email" class="field-label"
          >Email<span class="required" aria-hidden="true">*</span></label
        >
        <input
          id="inq-email"
          type="email"
          formControlName="email"
          class="field-input"
          [class.invalid]="emailCtrl.invalid && emailCtrl.touched"
          autocomplete="email"
          placeholder=""
          aria-required="true"
        />
        <span class="field-error" *ngIf="emailCtrl.invalid && emailCtrl.touched" role="alert">
          Please enter a valid email.
        </span>
      </div>

      <!-- Phone (Optional) -->
      <div class="form-field">
        <label for="inq-phone" class="field-label"
          >Phone <span class="required" aria-hidden="true">*</span></label
        >
        <input
          id="inq-phone"
          type="tel"
          formControlName="phone"
          class="field-input"
          [class.invalid]="form.controls.phone.invalid && form.controls.phone.touched"
          autocomplete="tel"
          placeholder=""
          aria-required="true"
        />
        <span
          class="field-error"
          *ngIf="form.controls.phone.invalid && form.controls.phone.touched"
          role="alert"
        >
          Please enter a valid phone number.
        </span>
      </div>

      <!-- Inquiry Type -->
      <div class="form-field">
        <label for="inq-type" class="field-label"
          >Subject <span class="required" aria-hidden="true">*</span></label
        >
        <select
          id="inq-type"
          formControlName="inquiryTypeId"
          class="field-input"
          [class.invalid]="inquiryTypeCtrl.invalid && inquiryTypeCtrl.touched"
          aria-required="true"
        >
          <option [ngValue]="0" disabled>Select inquiry subject</option>
          <option *ngFor="let t of inquiryTypes()" [ngValue]="t.inquiryTypeId">
            {{ t.inquiryTypeName }}
          </option>
        </select>
        <span
          class="field-error"
          *ngIf="inquiryTypeCtrl.invalid && inquiryTypeCtrl.touched"
          role="alert"
        >
          Please select a subject.
        </span>
      </div>

      <!-- Message -->
      <div class="form-field">
        <label for="inq-message" class="field-label">Message</label>
        <textarea
          id="inq-message"
          formControlName="message"
          class="field-input field-textarea"
          rows="3"
          placeholder=""
        ></textarea>
      </div>

      <!-- Actions -->
      <div class="modal-actions">
        <button
          type="button"
          class="btn-secondary"
          (click)="onClose()"
          [disabled]="modalState() === 'submitting'"
        >
          Cancel
        </button>
        <button type="submit" class="btn-primary" [disabled]="modalState() === 'submitting'">
          <span *ngIf="modalState() !== 'submitting'">Send Inquiry</span>
          <span
            *ngIf="modalState() === 'submitting'"
            class="spinner"
            aria-label="Sending..."
          ></span>
        </button>
      </div>
    </form>
  </div>
</div>
